export default "__VITE_ASSET__BUF5UL1L__"